import axios from 'axios';
import querystring from 'querystring';

// ไฟล์นี้ถูก import ตั้งแต่ตอนแอปเริ่มทำงาน (ผ่าน utils/FileUploadAuth.js ใน index.js)
// ถ้า env ไม่ได้ตั้งไว้ต้องไม่ทำให้ทั้งแอปพังตั้งแต่ boot แค่ให้ฟีเจอร์ไฟล์ใช้ไม่ได้พอ
const FILE_UPLOAD_BASE_URL = (
    process.env.REACT_APP_FILE_UPLOAD_URL || ''
).replace(/\/$/, '');

/**
 * ดึงรายการไฟล์แนบจาก isb-api (ตาราง FileStorage)
 *
 * เดิม frontend ยิงตรงไปที่ list API ของ file-manage ซึ่งเป็นคนละ service
 * คนละ JWT secret กับ isb-api จึงได้ 401 เสมอ ทั้ง dev และ prd
 *
 * @param {Object} params
 * @param {string} params.company - รหัสบริษัท
 * @param {string} params.relatedId - เลขที่เอกสาร / รหัสสินค้า
 * @param {string} [params.relatedType] - ประเภทเอกสาร เช่น EIP
 * @param {Object} [options]
 * @param {Object} [options.cancelToken] - Axios cancel token (ถ้ามี)
 * @returns {Promise<Array>} - รายการไฟล์ หรือ [] ถ้าไม่พบ / เกิดข้อผิดพลาด
 */
export const fetchFileStorage = async ({ company, relatedId, relatedType }, options = {}) => {
    if (!company || !relatedId) return [];

    try {
        const params = { company, relatedId };
        if (relatedType) params.relatedType = relatedType;

        const queryString = querystring.stringify(params);
        const url = `${process.env.REACT_APP_API_URL}fileStorage?${queryString}`;

        const config = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('x-access-token')}`
            }
        };

        if (options.cancelToken) {
            config.cancelToken = options.cancelToken;
        }

        const result = await axios.get(url, config);
        const data = result.data?.data;

        return Array.isArray(data) ? data : [];
    } catch (error) {
        if (axios.isCancel(error)) return [];
        console.error('fetchFileStorage error:', error);
        return [];
    }
};

/**
 * ประกอบ URL สำหรับดึงตัวไฟล์จาก file-manage โดยตรง
 *
 * route ที่เสิร์ฟตัวไฟล์ของ file-manage ไม่มี auth guard จึงไม่ต้องแนบ token
 * (เดิมโค้ดต่อ ?token=... ท้าย URL ซึ่งทำให้ token รั่วเข้า access log)
 *
 * @param {Object} fileData - แถวข้อมูลจากตาราง FileStorage
 * @param {Object} [fallback] - ใช้ประกอบ path เมื่อไม่มี FilePath
 * @returns {string} - URL เต็ม หรือ '' ถ้าประกอบไม่ได้
 */
export const getFileStorageUrl = (fileData, fallback = {}) => {
    const filePath = fileData?.FilePath || fileData?.filePath || fileData?.path || '';
    const fileName = fileData?.FileName || fileData?.fileName || fileData?.name || '';
    const fileUrl = fileData?.FileUrl || fileData?.fileUrl || fileData?.url || '';

    if (fileUrl && fileUrl.startsWith('http')) return fileUrl;
    if (filePath && filePath.startsWith('http')) return filePath;

    if (filePath) {
        return filePath.endsWith(fileName)
            ? `${FILE_UPLOAD_BASE_URL}/${filePath}`
            : `${FILE_UPLOAD_BASE_URL}/${filePath}/${fileName}`;
    }

    const { company, relatedType, relatedId } = fallback;
    if (company && relatedType && relatedId && fileName) {
        return `${FILE_UPLOAD_BASE_URL}/${company}/${relatedType}/${relatedId}/${fileName}`;
    }

    return fileName ? `${FILE_UPLOAD_BASE_URL}/${fileName}` : '';
};

export { FILE_UPLOAD_BASE_URL };
